interface Props {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export function PrimaryCTA({ label, onClick, disabled = false }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="group inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-brand-500 px-6 py-[18px] text-base font-semibold text-white shadow-[0_8px_20px_-8px_rgba(21,120,207,0.55)] transition active:scale-[0.985] hover:bg-brand-600 disabled:opacity-60 disabled:active:scale-100 sm:text-[17px]"
    >
      <span>{label}</span>
      <svg
        viewBox="0 0 16 16"
        className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M5 3l5 5-5 5" />
      </svg>
    </button>
  );
}
